export default "__VITE_ASSET__$q1PaheC__"